import React from 'react'
import Navbar from '../../components/navbar/Navbar'
import ProductReport from '../../components/reports/ProductReport'

const ProductPage = () => {
    return (
        <>

            <section className="bajaj_main_block">
                <div className="container-fluid">
                    {/* Navbar */}
                    <div className="row">
                        <div className="col-12 p-0">
                            <Navbar content="PRODUCT REPORT" />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 p-0">
                            <ProductReport />
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default ProductPage